import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const SecondaryColors = createInteractiveColorVars('secondary', true);
const SecondaryColorsLightValues = Object.freeze({
    base: {
        default: '#5A00EE',
        action: '#3F00A3',
        active: '#5A00EE',
        activeAction: '#3F00A3',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
    alpha: {
        alpha20: '#5A00EE33',
        alpha50: '#3F00A37F',
        alpha80: '#5A00EECC',
    },
});
const SecondaryColorsDarkValues = Object.freeze({
    base: {
        default: '#BD99F8',
        action: '#8168A9',
        active: '#BD99F8',
        activeAction: '#8168A9',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
    alpha: {
        alpha20: '#BD99F833',
        alpha50: '#BD99F87F',
        alpha80: '#BD99F8CC',
    },
});

export { SecondaryColors, SecondaryColorsDarkValues, SecondaryColorsLightValues };
